import { computed as i } from "vue";
import { getColKey as m, createCustomWidthStyle as I } from "./ghl-ui.es1324.js";
import { formatLength as k } from "./ghl-ui.es1008.js";
function E(d, r) {
  const s = [], R = [], y = [], c = /* @__PURE__ */ new WeakMap();
  let p = -1, u = 0, h = !1;
  function x(w, t) {
    t > p && (s[t] = [], p = t);
    for (const e of w)
      if ("children" in e)
        x(e.children, t + 1);
      else {
        const o = "key" in e ? e.key : void 0;
        R.push({
          key: m(e),
          style: I(e, o !== void 0 ? k(r(o)) : void 0),
          column: e
        }), u += 1, h || (h = !!e.ellipsis), y.push(e);
      }
  }
  x(d, 0);
  let n = 0;
  function L(w, t) {
    let e = 0;
    w.forEach((o, g) => {
      var C;
      if ("children" in o) {
        const l = n, a = {
          column: o,
          colSpan: 0,
          rowSpan: 1,
          isLast: !1
        };
        L(o.children, t + 1), o.children.forEach((f) => {
          var S, v;
          a.colSpan += (v = (S = c.get(f)) === null || S === void 0 ? void 0 : S.colSpan) !== null && v !== void 0 ? v : 0;
        }), l + a.colSpan === u && (a.isLast = !0), c.set(o, a), s[t].push(a);
      } else {
        if (n < e) {
          n += 1;
          return;
        }
        let l = 1;
        "titleColSpan" in o && (l = (C = o.titleColSpan) !== null && C !== void 0 ? C : 1), l > 1 && (e = n + l);
        const a = n + l === u, f = {
          column: o,
          colSpan: l,
          rowSpan: p - t + 1,
          isLast: a
        };
        c.set(o, f), s[t].push(f), n += 1;
      }
    });
  }
  return L(d, 0), {
    hasEllipsis: h,
    rows: s,
    cols: R,
    dataRelatedCols: y
  };
}
function W(d, r) {
  const s = i(() => E(d.columns, r));
  return {
    rowsRef: i(() => s.value.rows),
    colsRef: i(() => s.value.cols),
    hasEllipsisRef: i(() => s.value.hasEllipsis),
    dataRelatedColsRef: i(() => s.value.dataRelatedCols)
  };
}
export {
  W as useGroupHeader
};
